// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"QuickSearchResultsContainer_backdrop__lBnrl","noBackdrop":"QuickSearchResultsContainer_noBackdrop__PJBSb","focusGuard":"QuickSearchResultsContainer_focusGuard__tNWjc"};